<template>
    <div class="view">
        <div class="view-title">
            Горячая линия по вопросам online обучения
        </div>
        <section class="contacts">
            <div class="block">
                <strong class="title">Техническая поддержка:</strong>
                <div class="text">
                    <span style="font-size: 24px">+7 (925) 443-19-21</span> <br/>
                    (WhatsApp, Viber, Telegram) <br>
                    oorkk@uni-dubna.ru
                </div>
            </div>

            <div class="block">
                <strong class="title">Учебная поддержка:</strong>
                <div class="text">
                    <span style="font-size: 24px">+7 (965) 357-66-77 </span> <br>
                    (WhatsApp, Viber, Telegram)
                    edu@uni-dubna.ru
                </div>
            </div>

            <div class="block">
                <strong class="title">Юридическая поддержка:</strong>
                <div class="text">
                    <span style="font-size: 24px">+ 7 (496) 216-60-09</span>
                    Law.unidubna@gmail.com
                </div>
            </div>

            <div class="block">
                <strong class="title" style="font-size: 18px">Министерство Образования Московской области:</strong>
                <div class="text">
                    <span style="font-size: 24px">+ 7 (926) 092-05-14</span>
                    Коровкина Наталья Николаевна<br>
                    <span style="font-size: 16px">(экстренные случаи, при отсутствии получения обратной связи от университета)</span>
                </div>
            </div>

        </section>
        <section class="links">
            <div class="row" v-for="(row, rowindex) in links" :key="rowindex">
                <div class="block" v-for="(link, index) in row" :key="index">
                    <router-link class="link" :to="link.url" v-if="link.type == 'route'">
                        <img :src="require('../assets/' + link.image)" alt="">
                        <span class="title">{{link.title}}</span>
                        <div class="text" v-html="link.text"></div>
                    </router-link>

                    <a class="link" :href="link.url" v-if="link.type == 'link'">
                        <img :src="require('../assets/' + link.image)" alt="">
                        <span class="title">{{link.title}}</span>
                        <div class="text" v-html="link.text"></div>
                    </a>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "Help",
        data() {
            return {
                links: [
                    [
                        {
                            image: 'unilogo.png',
                            title: "Приказы",
                            text: "Университета \"Дубна\"",
                            type: "route",
                            url: "/order_uni"
                        },
                        {
                            image: 'minest.webp',
                            title: "Приказы",
                            text: "Министерства образования<br>\n" +
                                "Московской области",
                            type: "route",
                            url: "/order_minobrmo"
                        },
                        {
                            image: 'icons/15_blue.png',
                            title: "Расписание занятий",
                            text: "",
                            type: "link",
                            url: "https://docs.google.com/spreadsheets/d/1xq8uggaJMFQvcRd3ptDQZNnDle3dMpDGrdUw0qRY3DY/edit#gid=755391587"
                        },
                    ],



                    [
                        {
                            image: 'icons/25.png',
                            title: "ИНСТРУКЦИЯ-ПАМЯТКА",
                            text: "",
                            type: "route",
                            url: "/guide"
                        },
                        {
                            image: 'icons/40.webp',
                            title: "ОБРАЩЕНИЕ К СТУДЕНТАМ, РОДИТЕЛЯМ И ППС О ПЕРЕХОДЕ НА ДИСТАНЦИОННОЕ ОБУЧЕНИЕ",
                            text: "",
                            type: "route",
                            url: "/appeal"
                        },
                        {
                            image: 'icons/bubblequestion.webp',
                            title: "ЧАСТО ЗАДАВАЕМЫЕ ВОПРОСЫ",
                            text: "",
                            type: "link",
                            url: "/faq"
                        },
                    ]
                ]
            }
        }
    }
</script>

<style scoped>
    .view-title{
        font-size: 40px;
        color: #18224b;
        line-height: 1.23;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        padding: 20px 0 60px 0;
    }

    .contacts{
        background-color: white;
        display: flex;
        justify-content: center;
        padding: 15px 0;
    }

    .contacts .block{
        width: 260px;
        margin: 0 20px;
        text-align: center;
        font-family: 'PT Sans',Arial,sans-serif;
        font-size: 22px;
        line-height: 1.55;
    }

    .links .row{
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        box-sizing: border-box;
    }

    .links .row .block{
        width: 360px;
        height: 250px;
        margin: 0 20px;
        display: flex;
        justify-content: center;
    }

    .links .row .block .link{
        display: flex;
        flex-direction: column;
        align-items: center;
        text-decoration: none;
        width: 320px;
    }

    .links .row .block .link img{
        width: 70px;
        height: 70px;
        margin-bottom: 14px;
    }

    .links .row .block .link .title{
        font-size: 24px;
        line-height: 30px;
        margin-bottom: 25px;
        margin-top: 18px;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        color: #000;
        text-transform: uppercase;
    }

    .links .row .block .link .text{
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 400;
        color: #000;
    }

    @media (max-width: 1211px){
        .contacts .block{
            width: 220px;
            margin: 0 10px;
            text-align: center;
            font-family: 'PT Sans',Arial,sans-serif;
            font-size: 20px;
            line-height: 1.55;
        }

        .contacts .block .title{
            font-size: 20px;
        }

        .links .row .block{
            width: 260px;
            height: 250px;
            margin: 0 10px;
            display: flex;
            justify-content: center;
        }

    }

    @media (max-width: 850px){

        .view-title{
            font-size: 35px;
            color: #18224b;
            line-height: 1.23;
            font-family: 'PT Sans',Arial,sans-serif;
            font-weight: 600;
            padding: 20px 0 60px 0;
        }

        .contacts{
            background-color: white;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 15px 0;
        }

        .contacts .block{
            width: 260px;
            margin: 15px 20px;
            text-align: center;
            font-family: 'PT Sans',Arial,sans-serif;
            font-size: 22px;
            line-height: 1.55;
        }

        .contacts .block .title{
            font-size: 22px;
        }



        .links .row{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding-top: 15px;
            box-sizing: border-box;
        }

        .links .row .block{
            width: 360px;
            height: auto;
            margin: 15px 20px;
            display: flex;
            justify-content: center;
        }
    }


</style>